import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import img1 from '../../assets/images/reviewpic1.png';
import img2 from '../../assets/images/reviewpic2.png';
import img3 from '../../assets/images/reviewpic3.png';
import img4 from '../../assets/images/reviewpic4.png';
import img5 from '../../assets/images/reviewpic5.png';

const testimonials = [
  {
    stars: 5,
    feedback:
      'The Soft Skills course helped me improve my confidence, body language, and workplace etiquette. I now communicate more effectively with my team.',
    name: 'Rahul Sharma',
    title: 'Soft Skill',
    image: img1,
  },
  {
    stars: 5,
    feedback:
      'Advanced Soft Skills training sharpened my leadership, negotiation, workplace etiquette, and problem-solving abilities. It’s made me a stronger professional.',
    name: 'Vikram Joshi',
    title: 'Advanced Soft Skill',
    image: img2,
  },
  {
    stars: 5,
    feedback:
      'This course on Enterprise Sales Leadership transformed my approach. I learned how to lead sales teams, close big deals, and think strategically.',
    name: 'Suraj Rao',
    title: 'Enterprise Sales Leadership Skill',
    image: img3,
  },
  {
    stars: 5,
    feedback:
      'Communication Mastery taught me to speak with clarity and influence. I’m now confidently leading meetings and presenting ideas to executives.',
    name: 'Ashi Mehta',
    title: 'Communication Mastery',
    image: img4,
  },
  {
    stars: 5,
    feedback:
      'The Emotional Intelligence module helped me handle stress, lead with empathy, and build better team dynamics. It changed my leadership style.',
    name: 'Ananya Gupta',
    title: 'Emotional Intelligence for Leaders',
    image: img5,
  },
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="py-14 px-6 bg-white">
      <h2 className="text-4xl font-bold text-center text-[#fc3c04] mb-12">
        What Our <span className='text-[#345bf3]'>Students Say</span> 
      </h2>
      <div className="max-w-7xl mx-auto">
        <Slider {...settings}>
          {testimonials.map((t, index) => (
            <div key={index} className="p-4">
              <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition duration-300 h-full flex flex-col justify-between">
                <div>
                  <div className="flex items-center mb-4 text-yellow-400 text-xl">
                    {Array.from({ length: t.stars }, (_, i) => (
                      <span key={i}>★</span>
                    ))}
                  </div>
                  <p className="text-gray-700 mb-6 text-justify text-base leading-relaxed">
                    {t.feedback}
                  </p>
                </div>
                <div className="flex items-center gap-4 mt-auto">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-24 h-24 rounded-full object-cover"
                  />
                  <div>
                    <p className="font-semibold text-[#fc3c04] text-lg">{t.name}</p>
                    <p className="text-sm text-gray-500">{t.title}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
